import { Button, Col, Form, Popconfirm } from "antd";
import { ReactNode } from "react";
import { Center } from "../../baseInfo/center";
import { ICenterProps } from "../../baseInfo/center/interfaces";
import { damageCaseIssuerTypesOptions, damageCaseStatusOptions, enmDamageCaseStatus, IDamageCase, IDamageCaseFetchingInfo, IDamageCaseInitialData, IDamageCaseProps, IDamageCaseStates } from "../../baseInfo/damageCase/interfaces";
import { BaseEntityManager, } from "../../components/entityManager";
import { ColumnFilter } from "../../components/entityManager/columnfilter";
import { enmControlType, enmPropertyType, IMetadata, IProperty } from "../../components/entityManager/interfaces";
import { ComparisonFilter, enmConditionalOperators } from "../../components/infrastructure/filtering";
import { enmOrderingType, ICallOptions } from "../../components/infrastructure/models";

export class ReceiveDepreciated extends BaseEntityManager<IDamageCase, IDamageCaseProps, IDamageCaseStates, IDamageCaseFetchingInfo, IDamageCaseInitialData>{
    static initMetadata = (): IMetadata => {
        return {
            name: "ReceiveDepreciated",
            title: "دریافت داغی",
            Properties: [
                {
                    title: "شماره پرونده خسارت",
                    dataIndex: "Code",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.numberinput,
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "شماره پیگیری",
                    dataIndex: "TicketNo",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.numberinput,
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "صادر کننده خسارت",
                    dataIndex: "IssuerType",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.combobox,
                    combobox: { options: damageCaseIssuerTypesOptions },
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "وضعیت پرونده",
                    dataIndex: "Status",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.combobox,
                    combobox: {
                        optionsFunc: (_: any, record: IDamageCase) => damageCaseStatusOptions.map(o => {
                            if (!record)
                                return { title: o.title, value: o.value };
                            if (record.Status === enmDamageCaseStatus.ReceiveDepreciated && record.DamageTypeId !== 2)
                                return { title: 'در انتظار تایید انتقال مالکیت', value: o.value };
                            return { title: o.title, value: o.value };
                        })
                    },
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "مرکز ارزیابی",
                    dataIndex: "EvaluatorId",
                    controlType: enmControlType.template,
                    filterable: false,
                    sortable: false,
                    renderColumn: (_: any, record: IDamageCase) => {
                        let evaluator = record.DamageCaseEvaluators[record.DamageCaseEvaluators.length - 1]?.Evaluator;
                        return (
                            <>
                                {evaluator?.FullName}
                            </>
                        );
                    },
                    renderControl: (currentEntity: IDamageCase) => {
                        let evaluator = currentEntity.DamageCaseEvaluators[currentEntity.DamageCaseEvaluators.length - 1]?.Evaluator;
                        return (
                            <>
                                {evaluator?.FullName}
                            </>
                        );
                    },
                    width: 200
                },
                {
                    title: "سریال بیمه نامه",
                    dataIndex: "PolicyEquipmentModel.Policy.SerialNo",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150
                },
                {
                    title: "کد ملی بیمه گزار/مشتری",
                    dataIndex: "PolicyEquipmentModel.Policy.Policyholder.NationalCode",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150
                },
                {
                    title: "بیمه گزار/مشتری",
                    dataIndex: "PolicyEquipmentModel.Policy.Policyholder.FullName",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: false,
                    sortable: false,
                    width: 200
                },
                {
                    title: "نوع تجهیز",
                    dataIndex: "PolicyEquipmentModel.Equipment.Name",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 120
                },
                {
                    title: "برند",
                    dataIndex: "PolicyEquipmentModel.BrandTitle",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    sortable: true,
                    width: 120
                },
                {
                    title: "مدل",
                    dataIndex: "PolicyEquipmentModel.EquipmentModelTitle",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    sortable: true,
                    width: 120
                },
                {
                    title: "تایید انتقال مالکیت",
                    dataIndex: "PossessionTransition",
                    propertyType: enmPropertyType.boolean,
                    controlType: enmControlType.checkbox,
                    filterable: true,
                    width: 120
                },
                {
                    title: "تایید دریافت داغی",
                    dataIndex: "ReceiveDepreciated",
                    propertyType: enmPropertyType.boolean,
                    controlType: enmControlType.checkbox,
                    filterable: true,
                    width: 120
                },
                {
                    title: "تاریخ خسارت",
                    dataIndex: "DamageDate",
                    propertyType: enmPropertyType.date,
                    controlType: enmControlType.date,
                    disabled: true,
                    filterable: true,
                    showColumn: false,
                    width: 150
                },
                {
                    title: "شماره تماس بیمه گزار/مشتری",
                    dataIndex: "EmergencyCallNumber",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    disabled: true,
                    filterable: true,
                    showColumn: false,
                    width: 150
                }
            ]
        };
    }
    private evaluatorFilterProp: IProperty = {
        dataIndex: "EvaluatorFilterProp",
        controlType: enmControlType.lookup,
        propertyType: enmPropertyType.number,
        allowNull: true,
        title: "مرکز ارزیابی",
        lookup: {
            lookupComponent: Center,
            lookupDisplayFields: ["FullName"],
            dropdownDisplayFields: ["FullName", "NationalCode"],
            lookupProperty: ""
        }
    }
    private evaluatorFilterValue?: number;
    private evaluatorFilterOperator?: enmConditionalOperators;

    onInitializing() {
        this.searchable = true;
        this.searchArea = {
            columnsPerRow: 2
        };

        this.originalOrderings = () => [{ OrderBy: enmOrderingType.Descending, Property: "Id" }];

        this.onLoaded = () => {
            if (this.searchArea) {
                const { dataIndex, title } = this.evaluatorFilterProp;
                this.searchArea.render = () => {
                    return [
                        <Form.Item name={dataIndex} key={dataIndex} label={title}>
                            <ColumnFilter
                                parent={this}
                                property={this.evaluatorFilterProp}
                                onChange={currentFilter => {
                                    this.evaluatorFilterValue = !!currentFilter?.value ? currentFilter.value["Id"] : undefined;
                                    this.evaluatorFilterOperator = currentFilter?.operator;
                                }}
                                preparelookupProps={(lookupProps: ICenterProps) => {
                                    lookupProps.isEvaluator = true;
                                    return lookupProps;
                                }}
                            />
                        </Form.Item>
                    ];
                };
            }
        }

        this.onDataFetching = fetchingInfo => {
            if (!!this.evaluatorFilterValue && this.evaluatorFilterOperator !== undefined) {
                fetchingInfo.EvaluatorFilter = new ComparisonFilter("Evaluator.Id", this.evaluatorFilterOperator, this.evaluatorFilterValue);
            }

        };

        this.onDataFetched = result => {
            result && result.Data && result.Data.forEach(i => i.EmergencyCallNumber = '0' + i.EmergencyCallNumber);
            return result;
        };

        this.renderingToolbar = () => {
            const { selectedEntity } = this;
            if (!selectedEntity)
                return <></>;

            let result: ReactNode[] = [];

            // درصورتی که تایید انتقال مالکیت لازم باشد و انتقال مالکیت انجام نشده باشد
            if (!selectedEntity.PossessionTransition && selectedEntity.DamageType?.PossessionTransition) {
                result.push(
                    <Col key="ConfirmPossessionTransition" style={{ marginLeft: 10 }}>
                        <Popconfirm title="آیا انتقال مالکیت مورد تایید است؟" onConfirm={this.confirmPossessionTransition} >
                            <Button key="ConfirmPossessionTransitionButton" type="primary" >تایید انتقال مالکیت</Button>
                        </Popconfirm>
                    </Col>
                );
            }

            if (!selectedEntity.ReceiveDepreciated) {
                result.push(
                    <Col key="ConfirmReceiveDepreciated" style={{ marginLeft: 10 }}>
                        <Popconfirm title="آیا دریافت داغی مورد تایید است؟" onConfirm={this.confirmReceiveDepreciated} >
                            <Button key="ConfirmReceiveDepreciatedButton" type="primary" >تایید دریافت داغی</Button>
                        </Popconfirm>
                    </Col>
                );
            }

            return result.length ? (<> {result} </>) : (<></>);
        };
    }
    confirmReceiveDepreciated = async () => {
        if (!this.selectedEntity)
            return <></>;

        const damageCase = this.selectedEntity;

        let fetchOpt: ICallOptions = {
            url: "receivedepreciated/confirmReceiveDepreciated",
            data: { damageCaseId: damageCase.Id, rowVrsn: damageCase.RowVrsn },
            onSuccess: () => {
                this.fetchData();
            },
            onError: () => {

            }
        };
        await this.callApi(fetchOpt);
    }
    confirmPossessionTransition = async () => {
        if (!this.selectedEntity)
            return <></>;

        const damageCase = this.selectedEntity;

        let fetchOpt: ICallOptions = {
            url: "receivedepreciated/confirmPossessionTransition",
            data: { damageCaseId: damageCase.Id, rowVrsn: damageCase.RowVrsn },
            onSuccess: () => {
                this.fetchData();
            },
            onError: () => {

            }
        };
        await this.callApi(fetchOpt);
    }
}
